// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixData from 'wix-data';
import wixLocation from 'wix-location';

let categoryData;
let highlightFirst = true;

$w.onReady(async function () {
	console.log("reloading menu");
	
	categoryData = await wixData.query("category").find().then(results=>results.items);
	let categories = [];
	for (let c of categoryData) {
		if (categories.findIndex(x => x.title === c.title) < 0) {
			categories.push({title: c.title, _id: c._id});
		}
	}
	$w('#repeater2').data = [];
	console.log(categories);
	$w('#repeater2').data = categories;
	$w('#megaMenu').hide();
});

export function button5_mouseIn(event) {
	let button = $w.at(event.context)('#button5');
	if (!button.link) {
		button.style.backgroundColor = '#9C9C9C';
		$w("#megaMenu").show();
	}
}

export function button5_mouseOut(event) {
	let button = $w.at(event.context)('#button5');
	if (!button.link) {
		button.style.backgroundColor = '#ffffff';
		$w("#megaMenu").hide();
	}
}

export function repeater2_itemReady($item, itemData, index) {
	console.log('reloaded category column ' + itemData.title);
	$item('#categoryTitle').text = itemData.title;
	let rows = getSubCategoriesFor(itemData.title);
	$item('#subCategoryTable').columns = [
		{
			id: "title",
			dataPath: "title",
			width: 130
		}
	];
	$item('#subCategoryTable').rows = rows;
	console.log($item('#subCategoryTable').rows);
}

function getSubCategoriesFor (category) {
	let sc = [];
	for (let c of categoryData) {
		if (c.title === category) {
			sc.push({"title": c.subCategory, "url": c.url});
		}
	}
	return sc;
}


export function megaMenu_mouseIn(event) {
	$w('#megaMenu').show();
	//megaMenuButton.style.backgroundColor = '#9C9C9C';
}

export function megaMenu_mouseOut(event) {
	$w('#megaMenu').hide();
	//megaMenuButton.style.backgroundColor = '#ffffff';
}

export function subCategoryTable_rowSelect(event) {
	for (let c of categoryData) {
		if (c.subCategory === event.rowData.title) {
			wixLocation.to(c.url);
		}
	}
}